<template>
  <div class="bar">
    <svg v-if="!alt" class="border" width="568" height="36" viewBox="0 0 568 36" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M550.068 34.81H520.16v-6.548c-3.093 3.982-7.923 6.547-13.356 6.547h-29.908v-6.547c-3.092 3.982-7.923 6.547-13.354 6.547h-29.909v-6.547c-3.092 3.982-7.922 6.547-13.355 6.547H390.37v-6.547c-3.093 3.982-7.923 6.547-13.356 6.547h-29.907v-6.547c-3.093 3.982-7.923 6.547-13.356 6.547h-29.908v-6.547c-3.092 3.982-7.923 6.547-13.355 6.547H260.58v-6.547c-3.093 3.982-7.923 6.547-13.355 6.547h-29.908v-6.547c-3.093 3.982-7.924 6.547-13.356 6.547h-29.907v-6.547c-3.093 3.982-7.924 6.547-13.356 6.547H130.79v-6.547c-3.093 3.982-7.923 6.547-13.356 6.547H87.527v-6.547c-3.093 3.982-7.924 6.547-13.355 6.547H44.263v-6.547c-3.092 3.982-7.922 6.547-13.355 6.547H1V1h29.908C36.34 1 41.17 3.565 44.263 7.547V1h29.909c5.431 0 10.262 2.565 13.355 6.547V1h29.907c5.433 0 10.263 2.566 13.356 6.547V1h29.908c5.432 0 10.263 2.565 13.356 6.547V1h29.907c5.432 0 10.263 2.565 13.356 6.547V1h29.908c5.432 0 10.262 2.566 13.355 6.547V1h29.908c5.432 0 10.263 2.565 13.355 6.547V1h29.908c5.433 0 10.263 2.565 13.356 6.547V1h29.907c5.433 0 10.263 2.565 13.356 6.547V1h29.908c5.433 0 10.263 2.565 13.355 6.547V1h29.909c5.431 0 10.262 2.565 13.354 6.547V1h29.908c5.433 0 10.263 2.565 13.356 6.547V1h29.908c9.336 0 16.904 7.569 16.904 16.905 0 9.336-7.568 16.904-16.904 16.904" stroke="#918573" stroke-width="1" stroke-dasharray="4" stroke-linecap="round" stroke-linejoin="round"/></g></svg>
    <div
      class="mask"
      :style="maskStyle"
    >
      <svg :class="fillClasses" width="568" height="36" viewBox="0 0 568 36" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><path d="M550.068 34.81H520.16v-6.548c-3.093 3.982-7.923 6.547-13.356 6.547h-29.908v-6.547c-3.092 3.982-7.923 6.547-13.354 6.547h-29.909v-6.547c-3.092 3.982-7.922 6.547-13.355 6.547H390.37v-6.547c-3.093 3.982-7.923 6.547-13.356 6.547h-29.907v-6.547c-3.093 3.982-7.923 6.547-13.356 6.547h-29.908v-6.547c-3.092 3.982-7.923 6.547-13.355 6.547H260.58v-6.547c-3.093 3.982-7.923 6.547-13.355 6.547h-29.908v-6.547c-3.093 3.982-7.924 6.547-13.356 6.547h-29.907v-6.547c-3.093 3.982-7.924 6.547-13.356 6.547H130.79v-6.547c-3.093 3.982-7.923 6.547-13.356 6.547H87.527v-6.547c-3.093 3.982-7.924 6.547-13.355 6.547H44.263v-6.547c-3.092 3.982-7.922 6.547-13.355 6.547H1V1h29.908C36.34 1 41.17 3.565 44.263 7.547V1h29.909c5.431 0 10.262 2.565 13.355 6.547V1h29.907c5.433 0 10.263 2.566 13.356 6.547V1h29.908c5.432 0 10.263 2.565 13.356 6.547V1h29.907c5.432 0 10.263 2.565 13.356 6.547V1h29.908c5.432 0 10.262 2.566 13.355 6.547V1h29.908c5.432 0 10.263 2.565 13.355 6.547V1h29.908c5.433 0 10.263 2.565 13.356 6.547V1h29.907c5.433 0 10.263 2.565 13.356 6.547V1h29.908c5.433 0 10.263 2.565 13.355 6.547V1h29.909c5.431 0 10.262 2.565 13.354 6.547V1h29.908c5.433 0 10.263 2.565 13.356 6.547V1h29.908c9.336 0 16.904 7.569 16.904 16.905 0 9.336-7.568 16.904-16.904 16.904" /></g></svg>
      <span class="value">{{ percentage }}%</span>
    </div>
  </div>
</template>

<script>
import { mediaQueryMixin } from '@/mixins'

export default {
  name: 'PercentageBar',
  props: {
    percentage: {
      type: Number,
      required: true
    },
    strips: {
      type: Number,
      required: true
    },
    alt: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    stripOffset () {
      return (this.mobileSmall ? 194 : 180) + this.strips * (this.mobileSmall ? 38 : 42.69)
    },
    maskStyle () {
      return {
        'width': `${this.stripOffset}px`
      }
    },
    fillClasses () {
      return {
        'fill': true,
        'dark-fill': this.alt
      }
    }
  },
  mixins: [mediaQueryMixin]
}
</script>

<style lang="scss" scoped>
$height: 31.68px;

.bar {
  position: relative;
  height: 36px;
  margin: 0;
  left: -179px; // - 586 + 407

  @media (max-width: 374px) {
    left: -180px;
    height: $height;
  }
}

.border,
.mask,
.fill {
  position: absolute;
  top: 0;
  left: 0;
}

.border {
  z-index: 2;
}

.border,
.fill {
  @media (max-width: 374px) {
    width: 500px;
    height: $height;
  }
}

.mask {
  overflow: hidden;
  height: 36px;
  width: 0;
  border-radius: 0 18px 18px 0;
  z-index: 1;

  @media (max-width: 374px) {
    height: $height;
  }
}

.fill {
  fill: $c-pink;
}

.dark-fill {
  fill: #E94B4B;
}

.value {
  color: white;
  position: absolute;
  right: 9px;
  top: 9px;
  font-weight: $fw-bold;
  font-size: 16px;
  line-height: 1;
}
</style>
